export default __webpack_public_path__ + "static/media/home-application-testimonial-img03.25c8679c.png";